{
	"title": "Klanten",
	"description": "Iedereen die bestelt: gasten en klanten met een account.",
	"searchLabel": "Zoek op naam, e-mailadres of bedrijf",
	"empty": "Er zijn nog geen klanten.",
	"noName": "Geen naam",
	"column": {
		"customer": "Klant",
		"company": "Bedrijf",
		"kind": "Soort",
		"account": "Account",
		"created": "Klant sinds",
		"group": "Klantgroep"
	},
	"kind": {
		"label": "Soort",
		"consumer": "Particulier",
		"business": "Zakelijk"
	},
	"account": {
		"guest": "Gast",
		"unconfirmed": "Niet bevestigd",
		"confirmed": "Account"
	},
	"businessStatus": {
		"pending": "Aanvraag",
		"approved": "Goedgekeurd",
		"rejected": "Afgewezen",
		"label": "Aanvraag"
	},
	"anonymised": "Geanonimiseerd",
	"anonymisedTitle": "Geanonimiseerde klant",
	"detail": {
		"data": "Gegevens",
		"name": "Naam",
		"email": "E-mailadres",
		"phone": "Telefoonnummer",
		"kind": "Soort",
		"account": "Account",
		"accountSince": "Geregistreerd",
		"emailConfirmed": "E-mailadres bevestigd",
		"notConfirmed": "Nog niet",
		"newsletter": "Nieuwsbrief",
		"newsletterYes": "Aangemeld",
		"newsletterNo": "Niet aangemeld",
		"customerSince": "Klant sinds",
		"anonymisedAt": "Geanonimiseerd op {{date}}. Orders en facturen zijn bewaard; de persoonsgegevens zijn weg.",
		"unknown": "Onbekend"
	},
	"addresses": {
		"title": "Adressen",
		"description": "Het adres van de registratie en wat de klant in de shop heeft opgeslagen.",
		"empty": "Geen opgeslagen adressen.",
		"defaultBilling": "Standaard factuuradres",
		"defaultShipping": "Standaard verzendadres",
		"country": {
			"NL": "Nederland",
			"BE": "België"
		},
		"recipient": "t.a.v. {{name}}"
	},
	"business": {
		"title": "Zakelijk profiel",
		"none": "Deze klant heeft geen zakelijk account aangevraagd.",
		"companyName": "Bedrijfsnaam",
		"kvkNumber": "KvK-nummer",
		"vatId": "Btw-nummer",
		"status": "Aanvraag",
		"appliedAt": "Aangevraagd",
		"vies": "VIES",
		"viesName": "Naam volgens VIES",
		"viesAddress": "Adres volgens VIES",
		"viesResult": {
			"valid": "Geldig",
			"invalid": "Ongeldig",
			"unknown": "Onbekend"
		},
		"viesCheckedAt": "Gecontroleerd op {{date}}"
	},
	"orders": {
		"title": "Orders",
		"empty": "Orders van deze klant verschijnen hier zodra de shop bestellingen aanneemt."
	},
	"notes": {
		"title": "Notities",
		"description": "Alleen zichtbaar voor medewerkers, nooit in de shop.",
		"empty": "Nog geen notities.",
		"field": "Nieuwe notitie",
		"add": "Notitie toevoegen",
		"by": "{{name}} · {{date}}",
		"anonymised": "Bij een geanonimiseerde klant kun je geen notities meer zetten."
	},
	"anonymise": {
		"title": "Klant anonimiseren",
		"description": "Op verzoek van de klant (AVG). Orders en facturen blijven bewaard.",
		"action": "Anonimiseren",
		"confirmTitle": "{{email}} anonimiseren?",
		"confirmDescription": "Naam, telefoonnummer, e-mailadres en opgeslagen adressen worden gewist, het account wordt verwijderd en kan niet meer inloggen, en de nieuwsbriefaanmelding en notities verdwijnen. Het zakelijk profiel (bedrijfsnaam, KvK, btw-nummer) blijft staan. In het maillog blijft alleen staan dat er een mail is verstuurd. Dit kun je niet ongedaan maken.",
		"confirm": "Ja, anonimiseren",
		"already": "Deze klant is al geanonimiseerd."
	},
	"groupFilter": "Klantgroep",
	"decision": {
		"customerGroup": "Klantgroep",
		"paymentTerm": "Betaaltermijn",
		"days_one": "{{count}} dag",
		"days_other": "{{count}} dagen",
		"reverseCharge": "Btw verlegd",
		"yes": "Ja",
		"no": "Nee",
		"rejectionReason": "Reden van afwijzing",
		"decided": "Beoordeeld",
		"decidedBy": "{{name}} · {{date}}",
		"approve": "Goedkeuren",
		"reject": "Afwijzen",
		"changeTerms": "Voorwaarden wijzigen",
		"cancel": "Annuleren",
		"approveTitle": "Aanvraag goedkeuren",
		"approveDescription": "De klant krijgt een mail en ziet daarna de prijzen van de gekozen klantgroep, exclusief btw.",
		"changeTitle": "Voorwaarden wijzigen",
		"changeDescription": "Een wijziging geldt meteen. De klant krijgt hierover geen mail.",
		"groupField": "Klantgroep",
		"noGroups": "Er is nog geen zakelijke klantgroep. Maak er eerst een aan bij Instellingen → Klantgroepen.",
		"paymentTermField": "Betaaltermijn in dagen",
		"paymentTermHint": "Standaard 30 dagen.",
		"reverseChargeField": "Btw verleggen",
		"reverseChargeSuggested": "Voorgesteld: Belgisch btw-nummer dat VIES geldig vond. De klant betaalt 0% btw, met vermelding op de factuur.",
		"reverseChargeUnavailable": "Niet bij een Nederlands btw-nummer, en niet bij een btw-nummer dat VIES ongeldig vond.",
		"approveSubmit": "Goedkeuren en mailen",
		"saveTerms": "Opslaan",
		"rejectTitle": "Aanvraag afwijzen",
		"rejectDescription": "De klant krijgt een mail met de reden en kan daarna opnieuw aanvragen.",
		"reasonField": "Reden",
		"reasonHint": "Deze tekst komt letterlijk in de mail aan de klant.",
		"rejectSubmit": "Afwijzen en mailen",
		"notAllowed": "Deze aanvraag is intussen al beoordeeld. Ververs de pagina.",
		"groupInvalid": "Deze klantgroep bestaat niet meer. Kies een andere.",
		"reverseChargeNotAllowed": "Btw verleggen kan niet bij een Nederlands btw-nummer of een btw-nummer dat VIES ongeldig vond.",
		"reverseChargeUnknown": "VIES kon dit Belgische btw-nummer niet controleren. Je kunt de btw toch verleggen als je het nummer zelf hebt gecontroleerd.",
		"vatIdCheckedField": "Ik heb het btw-nummer zelf gecontroleerd",
		"vatIdCheckedHint": "We bewaren wie dit bevestigt en wanneer.",
		"vatIdCheckedKept": "Bevestigd door {{name}} op {{date}}; dat blijft staan.",
		"confirmationRequired": "Bevestig dat je het btw-nummer zelf hebt gecontroleerd.",
		"reverseChargeManual": "Ja, handmatig gecontroleerd door {{name}} · {{date}}"
	},
	"prices": {
		"title": "Klantprijzen",
		"description": "Vaste prijzen exclusief btw, alleen voor deze klant. Een klantprijs is definitief: er komt geen staffelkorting bovenop.",
		"notAllowed": "Klantprijzen zijn er alleen voor goedgekeurde zakelijke klanten.",
		"ignored": "Deze klant is geen goedgekeurde zakelijke klant meer: de prijzen hieronder gelden nu niet.",
		"empty": "Nog geen klantprijzen.",
		"product": "Variant",
		"groupPrice": "Prijs klantgroep",
		"price": "Klantprijs",
		"exclVat": "excl. btw",
		"edit": "Wijzigen",
		"editLabel": "Klantprijs voor {{name}} wijzigen",
		"remove": "Verwijderen",
		"removeLabel": "Klantprijs voor {{name}} verwijderen",
		"add": "Klantprijs toevoegen",
		"search": "Zoek een variant",
		"searchHint": "Op productnaam, variant, SKU of EAN.",
		"noResults": "Geen varianten gevonden.",
		"hasPrice": "heeft al een klantprijs",
		"choose": "Kiezen",
		"chosen": "Gekozen variant",
		"otherVariant": "Andere variant",
		"priceField": "Klantprijs excl. btw",
		"save": "Opslaan",
		"cancel": "Annuleren",
		"invalidPrice": "Vul een bedrag in, bijvoorbeeld 4,99.",
		"tooHigh": "Een klantprijs is hoogstens € 100.000.",
		"variantGone": "Deze variant bestaat niet meer.",
		"failed": "Opslaan lukte niet. Probeer het nog eens.",
		"archived": "Gearchiveerd",
		"archivedHint": "Het product is gearchiveerd. Zet het product eerst terug om deze klantprijs te wijzigen.",
		"productArchived": "Het product is gearchiveerd. Zet het product eerst terug."
	},
	"groupDelete": {
		"action": "Verwijderen",
		"title": "Klantgroep {{name}} verwijderen?",
		"description": "Producten met een afwijkende korting voor deze groep verliezen die. Dit kun je niet ongedaan maken.",
		"customers_one": "Deze groep heeft {{count}} klant. Kies de groep waar die klant naartoe gaat.",
		"customers_other": "Deze groep heeft {{count}} klanten. Kies de groep waar ze naartoe gaan.",
		"moveTo": "Klanten verplaatsen naar",
		"noOtherGroup": "Er is geen andere zakelijke klantgroep om de klanten naartoe te verplaatsen. Maak er eerst een aan.",
		"confirm": "Ja, verwijderen",
		"confirmMove": "Verplaatsen en verwijderen",
		"inUse": "Er zijn intussen klanten in deze groep gekomen. Sluit dit venster en probeer het opnieuw.",
		"gone": "Een van de klantgroepen bestaat niet meer. Ververs de pagina.",
		"consumerFixed": "Consument kun je niet verwijderen, en zakelijke klanten kunnen er niet naartoe.",
		"discountCodes_one": "Kortingscode {{codes}} geldt alleen voor deze groep. Haal de groep eerst uit die code.",
		"discountCodes_other": "Kortingscodes {{codes}} gelden alleen voor deze groep. Haal de groep eerst uit die codes."
	},
	"help": {
		"customers": {
			"title": "Klanten",
			"area": "Klanten",
			"short": "Iedereen die bestelt, met of zonder klantaccount. Zoek op naam, e-mailadres of bedrijf, en filter op soort, aanvraag of klantgroep. Open een klant voor zijn adressen, zakelijk profiel, klantprijzen en notities.",
			"terms": [
				"customer:customer",
				"customer:account",
				"customer:kind",
				"customer:application",
				"price:customerGroup"
			]
		},
		"customer": {
			"title": "Klant",
			"area": "Klanten",
			"short": "Iedereen die bestelt is een klant, ook een gast zonder account. Elke bestelling als gast maakt een nieuwe klant. Met een klantaccount bestelt iemand steeds als dezelfde klant.",
			"warning": "Bestelt iemand eerst als gast en maakt hij daarna een account, dan zijn dat twee klanten met hetzelfde e-mailadres. Zoek je op het adres, dan zie je ze allebei.",
			"terms": [
				"customer:account",
				"customer:data",
				"customer:addresses",
				"customer:businessProfile",
				"customer:customerPrice",
				"customer:notes",
				"customer:orders",
				"customer:anonymise"
			]
		},
		"kind": {
			"title": "Soort klant",
			"area": "Klanten",
			"short": "Particulier of zakelijk. Een klant is zakelijk zodra hij een zakelijk account aanvraagt. Wijs je de aanvraag af, dan is hij weer particulier.",
			"choices": [
				{
					"name": "Particulier",
					"text": "Zit in de klantgroep Consument en ziet de prijzen incl. btw."
				},
				{
					"name": "Zakelijk",
					"text": "Heeft een zakelijk profiel. Na goedkeuring ziet hij de prijzen van zijn klantgroep, standaard excl. btw. In zijn account kan hij incl. btw kiezen."
				}
			],
			"terms": ["customer:application", "price:customerGroup", "customer:businessProfile"]
		},
		"account": {
			"title": "Klantaccount",
			"area": "Klanten",
			"short": "Inloggen in de shop met e-mailadres en wachtwoord. Bij de registratie geeft de klant zijn naam, telefoonnummer en een adres op. Een gast bestelt zonder account.",
			"choices": [
				{
					"name": "Gast",
					"text": "Geen account: bestelde zonder in te loggen."
				},
				{
					"name": "Niet bevestigd",
					"text": "Geregistreerd, maar heeft de link in de bevestigingsmail nog niet geopend."
				},
				{
					"name": "Account",
					"text": "Geregistreerd, met een bevestigd e-mailadres."
				}
			],
			"terms": ["customer:email"]
		},
		"email": {
			"title": "E-mailadres",
			"area": "Klanten › Gegevens",
			"short": "Mail aan de klant gaat naar het adres zoals hij het typte. Voor de welkomstcode en het gebruik van een kortingscode door een gast telt het canonieke adres: kleine letters, zonder +tag, bij Gmail zonder punten.",
			"warning": "Zo zijn jan.jansen+shop@gmail.com en janjansen@gmail.com één inbox: samen krijgen ze één welkomstcode."
		},
		"data": {
			"title": "Gegevens",
			"area": "Klanten › Gegevens",
			"short": "Wat de klant bij de registratie of bij het afrekenen opgaf. Hier lees je het alleen: de klant wijzigt zijn naam en telefoonnummer zelf in de shop. Het e-mailadres is zijn login en blijft.",
			"terms": ["customer:kind", "customer:account", "customer:email"]
		},
		"addresses": {
			"title": "Adressen",
			"area": "Klanten › Adressen",
			"short": "De adressen die de klant in de shop opsloeg, het eerste bij de registratie. Elk adres kan voor de factuur en de verzending. Je ziet ze hier alleen: de klant wijzigt ze zelf.",
			"choices": [
				{
					"name": "Standaard factuuradres",
					"text": "Staat bij het afrekenen al ingevuld als factuuradres."
				},
				{
					"name": "Standaard verzendadres",
					"text": "Staat al ingevuld als verzendadres. Het mag hetzelfde adres zijn."
				}
			],
			"warning": "Een order heeft zijn eigen kopie van het adres. Wijzigt de klant een adres, dan verandert een geplaatste order niet."
		},
		"businessProfile": {
			"title": "Zakelijk profiel",
			"area": "Klanten › Zakelijk profiel",
			"short": "De bedrijfsgegevens uit de zakelijke aanvraag, met het btw-nummer en wat VIES ervan vond. Na goedkeuring ziet de klant de prijzen van zijn klantgroep, standaard excl. btw. In zijn account kan hij incl. kiezen.",
			"terms": [
				"customer:application",
				"customer:vies",
				"customer:decision",
				"price:customerGroup",
				"customer:paymentTerm",
				"customer:reverseCharge",
				"customer:customerPrice"
			]
		},
		"vies": {
			"title": "VIES",
			"area": "Klanten › Zakelijk profiel",
			"short": "Het register van de EU dat btw-nummers controleert. De shop vraagt het bij de aanvraag, en bewaart de naam en het adres die VIES bij het nummer kent.",
			"choices": [
				{
					"name": "Geldig",
					"text": "Het nummer bestaat. Bij een Belgisch nummer kun je de btw verleggen."
				},
				{
					"name": "Ongeldig",
					"text": "VIES kent het nummer niet. De btw verleggen kan dan niet."
				},
				{
					"name": "Onbekend",
					"text": "VIES gaf geen antwoord. Bij een Belgisch nummer mag je de btw toch verleggen als je het nummer zelf controleerde."
				}
			],
			"terms": ["customer:reverseCharge"]
		},
		"application": {
			"title": "Aanvraag",
			"area": "Klanten",
			"short": "Een klant vraagt in de shop een zakelijk account aan, met bedrijfsnaam, KvK-nummer en btw-nummer. Tot je de aanvraag goedkeurt, ziet hij de prijzen voor consumenten.",
			"choices": [
				{
					"name": "Aanvraag",
					"text": "Wacht op jouw beoordeling."
				},
				{
					"name": "Goedgekeurd",
					"text": "Zakelijke klant, met een klantgroep, een betaaltermijn en zo nodig btw verlegd."
				},
				{
					"name": "Afgewezen",
					"text": "De klant kreeg een mail met de reden en kan opnieuw aanvragen."
				}
			],
			"terms": ["customer:decision", "customer:businessProfile"]
		},
		"decision": {
			"title": "Aanvraag beoordelen",
			"area": "Klanten › Zakelijk profiel",
			"short": "Keur de aanvraag goed of wijs hem af. De klant krijgt in beide gevallen een mail.",
			"choices": [
				{
					"name": "Goedkeuren",
					"text": "Je kiest de klantgroep, de betaaltermijn en of de btw verlegd wordt. Daarna ziet de klant zijn prijzen excl. btw."
				},
				{
					"name": "Afwijzen",
					"text": "Je geeft een reden: die komt letterlijk in de mail. De klant kan daarna opnieuw aanvragen."
				}
			],
			"warning": "Wijzig je later de voorwaarden van een goedgekeurde klant, dan geldt dat meteen, en krijgt de klant geen mail.",
			"terms": ["price:customerGroup", "customer:paymentTerm", "customer:reverseCharge"]
		},
		"paymentTerm": {
			"title": "Betaaltermijn",
			"area": "Klanten › Zakelijk profiel",
			"short": "Een goedgekeurde zakelijke klant kan op rekening bestellen: hij bestelt nu en betaalt de factuur later via Pay.nl. De betaaltermijn is het aantal dagen dat hij daarvoor krijgt, standaard 30.",
			"warning": "Een nieuwe termijn geldt voor de volgende orders, niet voor een order die er al is."
		},
		"reverseCharge": {
			"title": "Btw verlegd",
			"area": "Klanten › Zakelijk profiel",
			"short": "Een Belgisch bedrijf met een geldig btw-nummer betaalt 0% btw op een order die naar België gaat, als je de btw bij de goedkeuring verlegt. De factuur vermeldt dat. Bij een Nederlands btw-nummer kan het niet.",
			"warning": "Kon VIES een Belgisch nummer niet controleren, dan mag het alleen als je het nummer zelf controleerde. Een order naar Nederland krijgt altijd btw.",
			"terms": ["customer:vies"]
		},
		"customerPrice": {
			"title": "Klantprijs",
			"area": "Klanten",
			"short": "Een vaste prijs excl. btw voor één zakelijke klant op één variant. Die wint altijd: er komt geen korting meer bij. Naast elke klantprijs zie je wat de klantgroep zou betalen.",
			"warning": "Alleen voor een goedgekeurde zakelijke klant. Ook een kortingscode verlaagt een klantprijs niet.",
			"terms": ["price:quantityDiscount", "price:customerGroup"]
		},
		"notes": {
			"title": "Klantnotities",
			"area": "Klanten › Notities",
			"short": "Notities over de klant, met wie ze schreef en wanneer. Alleen medewerkers zien ze: nooit de klant, niet in de shop en niet in een mail.",
			"warning": "Een notitie kun je niet wijzigen of verwijderen. Bij anonimiseren verdwijnen ze allemaal.",
			"terms": ["customer:anonymise"]
		},
		"orders": {
			"title": "Orders van een klant",
			"area": "Klanten › Orders",
			"short": "De orders van deze klant. Elke order bewaart zijn eigen kopie van de naam, de adressen en de prijzen: wat later bij de klant verandert, verandert geen geplaatste order.",
			"terms": ["customer:addresses"]
		},
		"anonymise": {
			"title": "Anonimiseren",
			"area": "Klanten › Klant anonimiseren",
			"short": "Op verzoek van de klant (AVG) haal je zijn persoonsgegevens weg. Orders en facturen blijven, want de boekhouding heeft ze nodig. Dit kun je niet ongedaan maken.",
			"choices": [
				{
					"name": "Gaat weg",
					"text": "Naam, telefoonnummer, e-mailadres, opgeslagen adressen, het account, de nieuwsbriefaanmelding, de notities, de voornaam bij reviews, de ontvanger in het maillog en het e-mailadres bij het gebruik van een kortingscode."
				},
				{
					"name": "Blijft",
					"text": "Orders en facturen met hun eigen kopie van de gegevens, en het zakelijk profiel: bedrijfsnaam, KvK-nummer en btw-nummer zijn geen persoonsgegevens."
				}
			],
			"warning": "Zonder account kan de klant niet meer inloggen. Bestelt hij later weer, dan is hij een nieuwe klant.",
			"terms": ["customer:businessProfile", "customer:notes"]
		}
	},
	"helpExample": {
		"product": "Floorwipes XXL",
		"variant": "20 doekjes",
		"group": "Zakelijk −10%",
		"sandbox": "Kies wat de klant is, en kijk wat hij in de shop ziet.",
		"who": "Wie bekijkt de shop",
		"as": {
			"consumer": "Particulier",
			"business": "Zakelijke groep",
			"own": "Met klantprijs"
		},
		"asText": {
			"consumer": "Prijzen incl. btw, met de staffel.",
			"business": "Prijzen excl. btw met 10% groepskorting, en de staffel daarbovenop.",
			"own": "Een vaste prijs van {{price}}. Geen staffel: de prijs per pak blijft gelijk bij elk aantal."
		},
		"quantity": "Aantal pakken",
		"less": "Een pak minder",
		"more": "Een pak meer",
		"shopLabel": "Voorbeeld uit de shop: de productpagina van Floorwipes XXL voor {{who}}. {{price}}{{staffel}} Knop: {{button}}.",
		"noStaffel": " Geen staffel.",
		"decision": {
			"animation": "Animatie: je klikt Goedkeuren, kiest de klantgroep Zakelijk −10%, laat de betaaltermijn op 30 dagen en klikt Goedkeuren en mailen. De aanvraag staat op Goedgekeurd en de klant krijgt een mail.",
			"steps": {
				"approve": "Klik Goedkeuren bij de aanvraag.",
				"group": "Kies de klantgroep.",
				"term": "Laat de betaaltermijn staan of pas hem aan.",
				"submit": "Klik Goedkeuren en mailen.",
				"done": "Goedgekeurd: de klant krijgt een mail en ziet zijn prijzen excl. btw."
			}
		},
		"company": "Schoonmaakbedrijf De Bezem",
		"mailed": "Mail aan de klant verstuurd"
	}
}
